/**
 * Preview-кадр камеры для рисования зон (B1 / FE-Z01).
 *
 * Каноническое пространство координат зоны — пиксели original-кадра. На
 * production список кадров приходит с `original: null` (хранится только
 * processed, уменьшенный scale_factor'ом: при 0.5 это 960×540 против
 * 1920×1080), поэтому processed здесь запрещён: снятые с него координаты не
 * совпадут с тем, что видит детектор. Источник original-кадра —
 * `GET /cameras/{id}.original` (reference-кадр камеры), запасной — original
 * последнего кадра, если backend его всё-таки отдаёт.
 */
export const extractOriginalFrameUrl = (frames) => {
  const frame = (Array.isArray(frames) ? frames : [])[0];
  return frame?.original?.url || '';
};

export const resolvePreviewFrameUrl = (camera, frames) =>
  camera?.original?.url || extractOriginalFrameUrl(frames);

/**
 * Превью карточки камеры (Кадры / Оборудование / Админка). Свежесть важнее
 * пространства координат: первым идёт processed последнего кадра (секундной
 * давности), запасным — `original` самой камеры: это reference-кадр,
 * обновляемый при старте камеры, зато он уже есть в списке камер и показывается
 * сразу, пока последний кадр ещё грузится. Для зон (resolvePreviewFrameUrl)
 * порядок обратный — там нужен именно original.
 */
export const resolveCameraCardPreviewUrl = (camera, lastFrame) =>
  lastFrame?.processed?.url || lastFrame?.original?.url || camera?.original?.url || '';
